
import axios from 'axios';
import { API_BASE } from './api';
import {DiscordUser} from "../types/simc";

const DISCORD_CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID;
const DISCORD_REDIRECT_URI = process.env.REACT_APP_DISCORD_REDIRECT_URI;

class AuthService {
    private static instance: AuthService;

    public static getInstance(): AuthService {
        if (!AuthService.instance) {
            AuthService.instance = new AuthService();
        }
        return AuthService.instance;
    }

    async login(): Promise<DiscordUser> {
        const response = await axios.get(`${API_BASE}/auth/me`);
        return response.data;
    }

    // Generate Discord OAuth URL
    getDiscordAuthUrl(): string {
        const scopes = ['identify', 'guilds'].join('%20');
        return `https://discord.com/api/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&redirect_uri=${encodeURIComponent(DISCORD_REDIRECT_URI!)}&response_type=code&scope=${scopes}`;
    }

    // Exchange code for tokens
    async exchangeCodeForTokens(code: string): Promise<DiscordUser> {
        const response = await axios.post(`${API_BASE}/auth/discord/callback`, {
            code,
            redirect_uri: DISCORD_REDIRECT_URI
        });
        return response.data;
    }
}

export default AuthService.getInstance();
